import argentina from '../assets/flags/argentina.webp'
import chile from '../assets/flags/chile.webp'
import ecuador from '../assets/flags/ecuador.webp'
import guatemala from '../assets/flags/guatemala.webp'
import mexico from '../assets/flags/mexico.webp'
import panama from '../assets/flags/panama.webp'
import paraguay from '../assets/flags/paraguay.webp'
import { COUNTRY_CODE, TELEGRAM_LINK } from './config'
import { AR, CL, EC, GT, MX, PA, PY } from './regions-and-cities'

export type CountryCode = 'AR' | 'CL' | 'EC' | 'GT' | 'MX' | 'PA' | 'PY'

export type MXStates = { id: string; label: string }[]

export type RegionsAndCities = { [key: string]: string[] }

type CountryInfo = {
  name: string
  zhName: string
  email: string
  flag: string
  addresses: MXStates | RegionsAndCities
  phoneCountryCode: string
  forms: {
    phoneLength: number
    postalCodeLength: number
    ruc?: {
      length: number
      placeholder: string
    }
  }
  gift?: number
  telegram?: string
  referralProgram?: {
    amount?: string
    timezone?: string
  }
  domain?: string
}

const COUNTRIES: Record<CountryCode, CountryInfo> = {
  AR: {
    name: 'Argentina',
    zhName: '阿根廷',
    email: 'soporte.ar@fun88.com',
    flag: argentina,
    addresses: AR,
    phoneCountryCode: '+54',
    forms: {
      phoneLength: 10,
      postalCodeLength: 4,
    },
    referralProgram: {
      timezone: '-3',
    },
  },
  CL: {
    name: 'Chile',
    zhName: '智利',
    email: 'soporte@fun88chile.com',
    flag: chile,
    addresses: CL,
    phoneCountryCode: '+56',
    telegram: TELEGRAM_LINK,
    forms: {
      phoneLength: 9,
      postalCodeLength: 7,
    },
    referralProgram: {
      amount: '$10,000',
      timezone: '-4',
    },
    domain: 'fun88.cl',
  },
  EC: {
    name: 'Ecuador',
    zhName: '厄瓜多尔',
    email: 'soporte.ec@fun88.com',
    flag: ecuador,
    addresses: EC,
    phoneCountryCode: '+593',
    forms: {
      phoneLength: 7,
      postalCodeLength: 6,
    },
    gift: 5,
    referralProgram: {
      amount: '$10',
      timezone: '-5',
    },
  },
  GT: {
    name: 'Guatemala',
    zhName: '危地马拉',
    email: 'soporte@fun88guatemala.com',
    flag: guatemala,
    addresses: GT,
    phoneCountryCode: '+502',
    forms: {
      phoneLength: 8,
      postalCodeLength: 5,
    },
  },
  MX: {
    name: 'Mexico',
    zhName: '墨西哥',
    email: 'soporte@fun88.mx',
    flag: mexico,
    addresses: MX,
    phoneCountryCode: '+52',
    gift: 50,
    forms: {
      phoneLength: 10,
      postalCodeLength: 5,
    },
    domain: 'fun88mx.mx',
  },
  PA: {
    name: 'Panama',
    zhName: '巴拿马',
    email: 'soporte@fun88panama.com',
    flag: panama,
    addresses: PA,
    phoneCountryCode: '+507',
    forms: {
      phoneLength: 8,
      ruc: {
        length: 13,
        placeholder: '1-234-567, 1-234-567-89, 1-234-5678-90',
      },
      postalCodeLength: 4,
    },
  },
  PY: {
    name: 'Paraguay',
    zhName: '巴拉圭',
    email: 'soporte@fun88paraguay.com',
    flag: paraguay,
    addresses: PY,
    phoneCountryCode: '+595',
    forms: {
      phoneLength: 9,
      ruc: {
        length: 8,
        placeholder: '12345678',
      },
      postalCodeLength: 4,
    },
  },
}

/**
 * Exporting current country data
 */
export const COUNTRY = COUNTRIES[COUNTRY_CODE]

/**
 * Check current country
 *
 * @param code - Country code:
 * - 'AR' = Argentina
 * - 'CL' = Chile
 * - 'EC' = Ecuador
 * - 'GT' = Guatemala
 * - 'MX' = Mexico
 * - 'PA' = Panama
 * - 'PY' = Paraguay
 */
export const IS_COUNTRY: Record<CountryCode, boolean> = {
  AR: COUNTRY_CODE === 'AR',
  CL: COUNTRY_CODE === 'CL',
  EC: COUNTRY_CODE === 'EC',
  GT: COUNTRY_CODE === 'GT',
  MX: COUNTRY_CODE === 'MX',
  PA: COUNTRY_CODE === 'PA',
  PY: COUNTRY_CODE === 'PY',
}

/**
 * Verify whether the argument includes the current country code.
 *
 * @param countries array of country codes
 * @returns true | false
 */
export const countryIncludes = (countries: CountryCode[] = []) =>
  countries.includes(COUNTRY_CODE)
